import React from "react";

export function CategoryTabs({ categories, active, onChange }) {
    return (
        <div
            data-testid="category-tabs"
            className="sticky top-0 md:top-16 z-30 -mx-4 md:-mx-8 px-4 md:px-8 glass border-b border-border/40 no-scrollbar overflow-x-auto py-3 md:py-4 flex gap-2 md:gap-3"
        >
            <button
                key="__all"
                onClick={() => onChange("")}
                data-testid="category-tab-all"
                className={`whitespace-nowrap px-4 py-2 rounded-full border text-sm font-medium transition-all ${
                    active === ""
                        ? "bg-foreground text-background border-foreground"
                        : "bg-transparent border-border/60 text-foreground hover:border-foreground"
                }`}
            >
                All
            </button>
            {categories.map((c) => (
                <button
                    key={c.id || c.name}
                    onClick={() => onChange(c.name)}
                    data-testid={`category-tab-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                    className={`whitespace-nowrap px-4 py-2 rounded-full border text-sm font-medium transition-all ${
                        active === c.name
                            ? "bg-foreground text-background border-foreground"
                            : "bg-transparent border-border/60 text-foreground hover:border-foreground"
                    }`}
                >
                    {c.name}
                </button>
            ))}
        </div>
    );
}
